import React from 'react'

export const TermsConditionsApp = () => {
  return (
        <div className='container'>
           <p>Términos de Servicio</p>
            <p><br/></p>
            <p>¿Quiénes somos?</p>
            <p><br/></p>
            <p>Nosotros proveemos servicios que te permiten el registro de boletos a eventos organizados dentro de nuestra aplicación, al igual que el poder organizar eventos y el escaneo de los boletos correspondientes que fueron adquiridos en la página web.</p>
            <p><br/></p>
            <p>Los servicios de AppAtemporal son proveídos por Rarr Inc. Localizada en r.vercel.app</p>
            <p><br/></p>
            <p>Restricciones de edad</p>
            <p><br/></p>
            <p>Al acceder a nuestros servicios, usted confirma que tiene por lo menos 18 años de edad, si se detecta que usted no cumple con este requisito esto se considerará; una violación a estos términos y se suspenderá; su cuenta.</p>
            <p><br/></p>
            <p>Tu cuenta de AppAtemporal</p>
            <p><br/></p>
            <p>Para poder acceder a los servicios que ofrecemos necesitarás crear una cuenta de Atemporal, para crear tu cuenta debes proveer tu nombr/e, apellido, fecha de nacimiento, género y número de teléfono, al crear una cuenta usted nos permite acceder a estos datos, los cuales no serán utilizados con ningún fin comercial.</p>
            <p><br/></p>
            <p>Usted es responsable de la seguridad de su cuenta y usted acepta que si cree que su cuenta está; comprometida nos va a contactar inmediatamente. Si usted utiliza un password, recomendamos que sea fuerte y le recomendamos (altamente recomendado) que sí utilice ese password para su cuenta de RARR. Si su cuenta está comprometida no le garantizamos que le sea restablecida.</p>
            <p><br/></p>
            <p>Usted también es responsable de mantener la precisión de sus datos de contacto, si pierde sus datos de inicio de sesión necesitaremos contactarlo en su correo electrónico o número de teléfono asociados a su cuenta y no podremos restablecer su cuenta si ya no tiene acceso a su correo electrónico o número de teléfono. También asumimos que cualquier comunicación que hayamos recibido desde su cuenta o datos de contacto asociados a su cuenta fueron hechos por usted.</p>
            <p><br/></p>
            <p>Usted acepta no licenciar, vender o transferir su cuenta sin nuestro consentimiento previo por escrito.</p>
            <p><br/></p>
            <p><br/></p>
            <p><br/></p>
            <p><br/></p>
            <p><br/></p>
            <p><br/></p>
            <p><br/></p>
        </div>
  )
}
